import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeModule } from './features/public/pages/home/home.module';
import { ContactComponent } from './features/public/pages/contact/contact.component';
import { LoginComponent } from './features/public/pages/login/login.component';
import { RegisterComponent } from './features/public/pages/register/register.component';
import { ForgotPasswordComponent } from './features/public/pages/forgot-password/forgot-password.component';
import { ProfileComponent } from './features/public/pages/profile/profile.component';
import { ProductDetailComponent } from './features/public/pages/product-detail/product-detail.component';
import { SubscriptionComponent } from './features/public/pages/subscription/subscription.component';
import { HomeComponent } from './features/public/pages/home/home.component';
import { NotificationsComponent } from './features/public/pages/notifications/notifications.component';
import { DevisComponent } from './features/public/pages/devis/devis.component';
import { MySpaceComponent } from './features/public/pages/my-space/my-space.component';
import { HistoryComponent } from './features/public/pages/history/history.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'accueil',
    pathMatch: 'full',
  },
  {
    path: 'accueil',
    component: HomeComponent,
    title: 'Accueil | Saarvie',
  },
  {
    path: 'profil',
    component: ProfileComponent,
    title: 'Profil | Saarvie',
    canActivate: [AuthGuard],
  },
  {
    path: 'mon-espace',
    component: MySpaceComponent,
    title: 'Mon espace | Saarvie',
    canActivate: [AuthGuard],
  },
  {
    path: 'historique',
    component: HistoryComponent,
    title: 'Historique | Saarvie',
    canActivate: [AuthGuard],
  },
  { path: 'devis', component: DevisComponent, title: 'Devis | Saarvie' },
  { path: 'devis/:productTypeId', component: DevisComponent, title: 'Devis | Saarvie' },
  { path: 'produits/:id', component: ProductDetailComponent, title: 'Produit | Saarvie' },
  {
    path: 'souscription/:productId',
    component: SubscriptionComponent,
    title: 'Souscription | Saarvie',
  },
  { path: 'nous-contacter', component: ContactComponent, title: 'À propos | Saarvie' },
  { path: 'se-connecter', component: LoginComponent, title: 'Se connecter | Saarvie' },
  { path: 'inscription', component: RegisterComponent, title: 'Inscription | Saarvie' },
  {
    path: 'mot-de-passe-oublie',
    component: ForgotPasswordComponent,
    title: 'Mot de passe oublié | Saarvie',
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    title: 'Notifications | Saarvie',
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'accueil' },
];

@NgModule({
  imports: [
    HomeModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
